import { createApiHook } from 'services/api/hooks';
import { assignCreativesApiFactory } from './assignCreativesApiFactory';

export const useAssignCreativesApi = createApiHook(assignCreativesApiFactory);
